import './AllSkills.css';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { getAllSkills, getAllSkillGroups } from '../../actions/skills';
import { getSkillTypeName } from '../../constants/skillTypes.js'

class AllSkills extends Component {
    componentDidMount() {        
        const { getAllSkills, getAllSkillGroups } = this.props;
        getAllSkills();
        getAllSkillGroups();
    }

    formatSkill(item) {
        console.log("Formatting skill: ", item);
        //getAllSkills returns the list of skills with the skill groups as IDs and the skill types as numbers.
        //So we need to do some formatting to get them to display right
        //This is made more complicated by the fact that when skills are created they are added to the state
        //formatted correctly, so we need to ignore newly created skills when trying to format.
        //That's what all this is.
        const { skillGroups } = this.props;
        var skill = {};
        skill.skillId = item.skillId;
        skill.skillName = item.skillName;
        if(!isNaN(item.skillType)) {
            //If the skilltype is just a number we have to get the type name
            skill.skillType = getSkillTypeName(item.skillType);                    
        }
        else {
            //if the skill was just added, the skill type will just be the name
            skill.skillType = item.skillType;
        }
        if((item.skillGroup.match(/\d/g) || []).length > 8) {
            //if a group name has 8 or more numbers in it, it is assumed to be an id, so we have to get the name of the group to display
            skill.skillGroup = skillGroups.find(group => group.skillGroupId === item.skillGroup).name;
        }
        else {
            //if the skill was just added, the name will just be there
            skill.skillGroup = item.skillGroup;
        }        
        return skill;
    }

    render() {
        const { allSkills, skillGroups } = this.props;
        var skills = []
        if(allSkills.length > 0 && skillGroups.length > 0) {
            skills = allSkills.map(item => {
                return this.formatSkill(item);                
            })
        }  
        return (
            <div className="skills-main">
                <div className="activity-skills-header">
                    <h3>All Skills</h3>
                </div>
                <BootstrapTable striped condensed pagination search data={skills} options={this.options} multiColumnSort={2}>
                    <TableHeaderColumn dataField='skillId' isKey hidden={true}>skillId</TableHeaderColumn>
                    <TableHeaderColumn dataField='skillName' dataSort>Skill Name</TableHeaderColumn>
                    <TableHeaderColumn dataField='skillGroup' dataSort>Skill Group Name</TableHeaderColumn>
                    <TableHeaderColumn dataField='skillType' dataSort width='20%'>Skill Type Name</TableHeaderColumn>
                </BootstrapTable>
            </div>          
        )
    }
}

AllSkills.propTypes = {
    getAllSkills: PropTypes.func.isRequired,
    getAllSkillGroups: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    allSkills: state.skills.allSkills,
    skillGroups: state.skills.skillGroups
});

const mapDispatchToProps = {
    getAllSkills,
    getAllSkillGroups
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AllSkills);



// WEBPACK FOOTER //
// ./src/components/allSkills/AllSkills.js